// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voucher-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 520px;
  max-height: min(90vh, 100dvh);
  min-height: 0;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
}
.voucher-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}
.voucher-dialog .dialog-header .dialog-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.3;
}
.voucher-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  --mat-mdc-button-persistent-ripple-color: transparent;
  --mat-mdc-button-ripple-color: transparent;
}
.voucher-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
}
.voucher-dialog .dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.voucher-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 20px 12px;
  -webkit-overflow-scrolling: touch;
}
.voucher-dialog .dialog-content .dialog-subtitle {
  margin: 0 0 16px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}
.voucher-dialog .dialog-content .voucher-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.voucher-dialog .dialog-content .voucher-form .full-width {
  width: 100%;
}
.voucher-dialog .dialog-content .feedback-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.5;
}
.voucher-dialog .dialog-content .feedback-row:has(.error) {
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.voucher-dialog .dialog-content .feedback-row:has(.success) {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}
.voucher-dialog .dialog-content .feedback-row .feedback-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}
.voucher-dialog .dialog-content .feedback-row .feedback-icon.error {
  color: #dc2626;
}
.voucher-dialog .dialog-content .feedback-row .feedback-icon.success {
  color: #16a34a;
}
.voucher-dialog .dialog-content .feedback-row .feedback-text.error {
  color: #b91c1c;
}
.voucher-dialog .dialog-content .feedback-row .feedback-text.success {
  color: #15803d;
}
.voucher-dialog .dialog-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}
.voucher-dialog .dialog-actions .btn-primary,
.voucher-dialog .dialog-actions .btn-secondary {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  min-height: 40px;
}
.voucher-dialog .dialog-actions .btn-primary {
  background: #5ea1d8;
  color: #fff;
}
.voucher-dialog .dialog-actions .btn-primary:hover {
  background: #4a8fc4;
}
.voucher-dialog .dialog-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}
.voucher-dialog .dialog-actions .btn-secondary:hover {
  background: #e5e7eb;
}

@media (max-width: 768px) {
  .voucher-dialog {
    max-width: calc(100vw - 24px);
    max-height: 95vh;
  }
  .voucher-dialog .dialog-header {
    padding: 14px 12px 14px 16px;
  }
  .voucher-dialog .dialog-content {
    padding: 16px 16px 10px;
  }
  .voucher-dialog .dialog-actions {
    padding: 14px 16px;
    flex-direction: column-reverse;
    gap: 10px;
  }
  .voucher-dialog .dialog-actions .btn-primary,
  .voucher-dialog .dialog-actions .btn-secondary {
    width: 100%;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .voucher-dialog {
    max-width: calc(100vw - 16px);
  }
  .voucher-dialog .dialog-header {
    padding: 12px 8px 12px 14px;
  }
  .voucher-dialog .dialog-header .dialog-title {
    font-size: 16px;
  }
  .voucher-dialog .dialog-content {
    padding: 14px 12px 8px;
  }
  .voucher-dialog .dialog-actions {
    padding: 12px 14px;
  }
}
:host-context(body.theme-dark) .voucher-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .voucher-dialog .dialog-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .voucher-dialog .dialog-content {
  background: #111827 !important;
}
:host-context(body.theme-dark) .voucher-dialog .dialog-actions {
  background: #0f172a !important;
  border-top-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .voucher-dialog .dialog-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .voucher-dialog .dialog-subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .voucher-dialog .close-button {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .voucher-dialog .close-button:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .voucher-dialog .feedback-row:has(.error) {
  background: rgba(220, 38, 38, 0.12) !important;
  border-color: rgba(220, 38, 38, 0.3) !important;
}
:host-context(body.theme-dark) .voucher-dialog .feedback-row:has(.success) {
  background: rgba(22, 163, 74, 0.12) !important;
  border-color: rgba(22, 163, 74, 0.3) !important;
}
:host-context(body.theme-dark) .voucher-dialog .btn-secondary {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .voucher-dialog .btn-secondary:hover {
  background: #374151 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.7) !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__trailing {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-floating-label,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-floating-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-floating-label--float-above,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-floating-label--float-above {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-input-element,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog input.mat-mdc-input-element {
  color: #f1f5f9 !important;
  caret-color: #f1f5f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-select-value-text,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-select-placeholder {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-select-arrow svg {
  fill: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-date-range-input-inner,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-date-range-input-separator {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-datepicker-toggle .mat-mdc-icon-button {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-form-field-hint,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-form-field-error {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled),
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-form-field,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-form-field-flex,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-form-field-infix,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mdc-text-field--outlined .mat-mdc-form-field-infix {
  background: transparent !important;
  background-color: transparent !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog input,
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-mdc-input-element {
  background: transparent !important;
  background-color: transparent !important;
  color: #f1f5f9 !important;
  caret-color: #f1f5f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .voucher-dialog .mat-date-range-input-inner::placeholder {
  color: #64748b !important;
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/vouchercode/vouchercode.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gCAAA;EACA,4BAAA;EACA,cAAA;AAAJ;AAEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAN;AAGI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,qDAAA;EACA,0CAAA;AADN;AAGM;EACE,mBAAA;EACA,cAAA;AADR;AAIM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFR;AAQE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iCAAA;AANJ;AAQI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANN;AASI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAPN;AASM;EACE,WAAA;AAPR;AAWI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AATN;AAWM;EACE,mBAAA;EACA,yBAAA;AATR;AAYM;EACE,mBAAA;EACA,yBAAA;AAVR;AAaM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAXR;AAaQ;EAAU,cAAA;AAVlB;AAWQ;EAAY,cAAA;AARpB;AAYQ;EAAU,cAAA;AATlB;AAUQ;EAAY,cAAA;AAPpB;AAaE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,cAAA;AAXJ;AAaI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AAXN;AAcI;EACE,mBAAA;EACA,WAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAgBI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAdN;AAgBM;EACE,mBAAA;AAdR;;AAqBA;EACE;IACE,6BAAA;IACA,gBAAA;EAlBF;EAoBE;IACE,4BAAA;EAlBJ;EAqBE;IACE,uBAAA;EAnBJ;EAsBE;IACE,kBAAA;IACA,8BAAA;IACA,SAAA;EApBJ;EAsBI;;IAEE,WAAA;IACA,uBAAA;EApBN;AACF;AAyBA;EACE;IACE,6BAAA;EAvBF;EAyBE;IACE,2BAAA;EAvBJ;EAyBI;IACE,eAAA;EAvBN;EA2BE;IACE,sBAAA;EAzBJ;EA4BE;IACE,kBAAA;EA1BJ;AACF;AAkCE;EACE,8BAAA;EACA,yBAAA;AAhCJ;AAmCE;EACE,8BAAA;EACA,wDAAA;AAjCJ;AAoCE;EACE,8BAAA;AAlCJ;AAqCE;EACE,8BAAA;EACA,sDAAA;AAnCJ;AAuCE;EACE,yBAAA;AArCJ;AAwCE;EACE,yBAAA;AAtCJ;AA0CE;EACE,yBAAA;AAxCJ;AA0CI;EACE,gDAAA;EACA,yBAAA;AAxCN;AA6CE;EACE,8CAAA;EACA,+CAAA;AA3CJ;AA8CE;EACE,8CAAA;EACA,+CAAA;AA5CJ;AAgDE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA9CJ;AAgDI;EACE,8BAAA;AA9CN;AAsDI;;;EAGE,kDAAA;AApDN;AAwDI;;;EAME,iDAAA;AAzDN;AA6DI;;;EAME,gCAAA;AA9DN;AAkEI;;EAEE,yBAAA;AAhEN;AAoEI;;EAEE,yBAAA;AAlEN;AAsEI;;EAEE,yBAAA;EACA,+BAAA;AApEN;AAwEI;;EAEE,yBAAA;AAtEN;AAyEI;EACE,wBAAA;AAvEN;AA2EI;;EAEE,yBAAA;AAzEN;AA6EI;EACE,yBAAA;AA3EN;AA+EI;;EAEE,yBAAA;AA7EN;AAmFI;;;;;;;EAOE,kCAAA;EACA,wCAAA;AAjFN;AAqFI;;EAEE,kCAAA;EACA,wCAAA;EACA,yBAAA;EACA,+BAAA;AAnFN;AAuFI;EACE,yBAAA;EACA,qBAAA;AArFN","sourcesContent":[".voucher-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 520px;\n  max-height: min(90vh, 100dvh);\n  min-height: 0;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  // ── Header ──────────────────────────────────────────────\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 16px 16px 20px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    border-radius: 12px 12px 0 0;\n    flex-shrink: 0;\n\n    .dialog-title {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #0f172a;\n      line-height: 1.3;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      flex-shrink: 0;\n      border-radius: 50%;\n      --mat-mdc-button-persistent-ripple-color: transparent;\n      --mat-mdc-button-ripple-color: transparent;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  // ── Content ─────────────────────────────────────────────\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 20px 20px 12px;\n    -webkit-overflow-scrolling: touch;\n\n    .dialog-subtitle {\n      margin: 0 0 16px;\n      font-size: 14px;\n      color: #4b5563;\n      line-height: 1.5;\n    }\n\n    .voucher-form {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .full-width {\n        width: 100%;\n      }\n    }\n\n    .feedback-row {\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n      padding: 10px 12px;\n      border-radius: 8px;\n      margin-top: 4px;\n      font-size: 13px;\n      line-height: 1.5;\n\n      &:has(.error) {\n        background: #fef2f2;\n        border: 1px solid #fecaca;\n      }\n\n      &:has(.success) {\n        background: #f0fdf4;\n        border: 1px solid #bbf7d0;\n      }\n\n      .feedback-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        flex-shrink: 0;\n        margin-top: 1px;\n\n        &.error { color: #dc2626; }\n        &.success { color: #16a34a; }\n      }\n\n      .feedback-text {\n        &.error { color: #b91c1c; }\n        &.success { color: #15803d; }\n      }\n    }\n  }\n\n  // ── Actions ─────────────────────────────────────────────\n  .dialog-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 16px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e2e8f0;\n    border-radius: 0 0 12px 12px;\n    flex-shrink: 0;\n\n    .btn-primary,\n    .btn-secondary {\n      padding: 10px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      font-family: 'Raleway', sans-serif;\n      cursor: pointer;\n      border: none;\n      transition: all 0.2s ease;\n      min-height: 40px;\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: #fff;\n\n      &:hover {\n        background: #4a8fc4;\n      }\n    }\n\n    .btn-secondary {\n      background: #f3f4f6;\n      color: #374151;\n      border: 1px solid #e5e7eb;\n\n      &:hover {\n        background: #e5e7eb;\n      }\n    }\n  }\n}\n\n// ── Responsive ──────────────────────────────────────────\n@media (max-width: 768px) {\n  .voucher-dialog {\n    max-width: calc(100vw - 24px);\n    max-height: 95vh;\n\n    .dialog-header {\n      padding: 14px 12px 14px 16px;\n    }\n\n    .dialog-content {\n      padding: 16px 16px 10px;\n    }\n\n    .dialog-actions {\n      padding: 14px 16px;\n      flex-direction: column-reverse;\n      gap: 10px;\n\n      .btn-primary,\n      .btn-secondary {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .voucher-dialog {\n    max-width: calc(100vw - 16px);\n\n    .dialog-header {\n      padding: 12px 8px 12px 14px;\n\n      .dialog-title {\n        font-size: 16px;\n      }\n    }\n\n    .dialog-content {\n      padding: 14px 12px 8px;\n    }\n\n    .dialog-actions {\n      padding: 12px 14px;\n    }\n  }\n}\n\n// ── Dark Mode ────────────────────────────────────────────\n:host-context(body.theme-dark) {\n\n  // Shell & layout regions\n  .voucher-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .voucher-dialog .dialog-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .voucher-dialog .dialog-content {\n    background: #111827 !important;\n  }\n\n  .voucher-dialog .dialog-actions {\n    background: #0f172a !important;\n    border-top-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // Text\n  .voucher-dialog .dialog-title {\n    color: #f1f5f9 !important;\n  }\n\n  .voucher-dialog .dialog-subtitle {\n    color: #94a3b8 !important;\n  }\n\n  // Close button\n  .voucher-dialog .close-button {\n    color: #94a3b8 !important;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.08) !important;\n      color: #e2e8f0 !important;\n    }\n  }\n\n  // Feedback rows\n  .voucher-dialog .feedback-row:has(.error) {\n    background: rgba(220, 38, 38, 0.12) !important;\n    border-color: rgba(220, 38, 38, 0.3) !important;\n  }\n\n  .voucher-dialog .feedback-row:has(.success) {\n    background: rgba(22, 163, 74, 0.12) !important;\n    border-color: rgba(22, 163, 74, 0.3) !important;\n  }\n\n  // Action buttons\n  .voucher-dialog .btn-secondary {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #374151 !important;\n    }\n  }\n\n  // ── Angular Material form-field internals (::ng-deep required) ──\n  ::ng-deep .voucher-dialog {\n\n    // Outlined border segments\n    .mdc-text-field--outlined .mdc-notched-outline__leading,\n    .mdc-text-field--outlined .mdc-notched-outline__notch,\n    .mdc-text-field--outlined .mdc-notched-outline__trailing {\n      border-color: rgba(148, 163, 184, 0.45) !important;\n    }\n\n    // Hover state – slightly brighter border\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover\n      .mdc-notched-outline__leading,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover\n      .mdc-notched-outline__notch,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled):hover\n      .mdc-notched-outline__trailing {\n      border-color: rgba(148, 163, 184, 0.7) !important;\n    }\n\n    // Focused state – brand blue border\n    .mdc-text-field--outlined.mdc-text-field--focused\n      .mdc-notched-outline__leading,\n    .mdc-text-field--outlined.mdc-text-field--focused\n      .mdc-notched-outline__notch,\n    .mdc-text-field--outlined.mdc-text-field--focused\n      .mdc-notched-outline__trailing {\n      border-color: #5ea1d8 !important;\n    }\n\n    // Floating label (resting position)\n    .mdc-floating-label,\n    .mat-mdc-floating-label {\n      color: #94a3b8 !important;\n    }\n\n    // Floating label (floated above field)\n    .mdc-floating-label--float-above,\n    .mat-mdc-floating-label--float-above {\n      color: #5ea1d8 !important;\n    }\n\n    // Input text & caret\n    .mat-mdc-input-element,\n    input.mat-mdc-input-element {\n      color: #f1f5f9 !important;\n      caret-color: #f1f5f9 !important;\n    }\n\n    // mat-select selected value & arrow\n    .mat-mdc-select-value-text,\n    .mat-mdc-select-placeholder {\n      color: #e2e8f0 !important;\n    }\n\n    .mat-mdc-select-arrow svg {\n      fill: #94a3b8 !important;\n    }\n\n    // Date-range inputs\n    .mat-date-range-input-inner,\n    .mat-date-range-input-separator {\n      color: #e2e8f0 !important;\n    }\n\n    // Datepicker toggle icon\n    .mat-datepicker-toggle .mat-mdc-icon-button {\n      color: #94a3b8 !important;\n    }\n\n    // Hint / subscript text\n    .mat-mdc-form-field-hint,\n    .mat-mdc-form-field-error {\n      color: #94a3b8 !important;\n    }\n\n    // Outlined fields must have transparent backgrounds — broad global rules\n    // set #1f2937 on .mdc-text-field and input inside .dialoguebox which bleeds\n    // outside the rounded outline border. Reset all layers to transparent.\n    .mdc-text-field--outlined,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled),\n    .mat-mdc-text-field-wrapper,\n    .mat-mdc-form-field,\n    .mat-mdc-form-field-flex,\n    .mat-mdc-form-field-infix,\n    .mdc-text-field--outlined .mat-mdc-form-field-infix {\n      background: transparent !important;\n      background-color: transparent !important;\n    }\n\n    // Input element itself — transparent so no fill escapes the outline border\n    input,\n    .mat-mdc-input-element {\n      background: transparent !important;\n      background-color: transparent !important;\n      color: #f1f5f9 !important;\n      caret-color: #f1f5f9 !important;\n    }\n\n    // Date-range inner inputs (matStartDate / matEndDate) still use placeholder\n    .mat-date-range-input-inner::placeholder {\n      color: #64748b !important;\n      opacity: 1 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
